import FormButton from "../../components/form-button";
import Countback from "../../components/countback";
import TournamentGames from "./games";
import TournamentLeaderboard from "./leaderboard";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import Loading from "../../components/loading";
import stringHelper from "../../helpers/string-helper";
import {LazyLoadImage} from "react-lazy-load-image-component";

const TournamentItem = props => {
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const {tournament} = props
    const [activeTab, setActiveTab] = useState('games')
    const [isLoading, setIsLoading] = useState(true);

    function onLoad() {
        setIsLoading(false)
    }

    const navigate = useNavigate()
    const handleDetail = () =>
        navigate(stringHelper.getLocalizedPath(currentLanguage, `/tournament/${tournament.uuid}`))


    return (
        <div className="col-12 col-md-6 col-xxl-4 mt-4">
            <div className="tournament tournament--grid">
                <div className="tournament__cover">
                    {/*<span className="tournament__status tournament__status--passing">*/}
                    {/*  Passing*/}
                    {/*</span>*/}
                    <div className="tournament__prize">
                        <span>{t('tournaments.total-reward')}</span>
                        <p>${tournament.prize}</p>
                    </div>
                    {
                        isLoading && <Loading/>
                    }

                    <LazyLoadImage
                        onLoad={onLoad}
                        height={'100%'}
                        width={'100%'}
                        effect="blur"
                        src={tournament.image}
                        placeholderSrc={tournament.image}
                        alt=""/>


                    {/*<img*/}
                    {/*    onLoad={onLoad}*/}
                    {/*    style={{height: isLoading ? "0" : ""}}*/}
                    {/*    src={tournament.image}*/}
                    {/*    loading="lazy"*/}
                    {/*    alt=""/>*/}
                </div>
                <div className="tournament__content">
                    <h3 className="tournament__title one-line-ellipsis">
                        {tournament?.title}
                        {/*<a href="tournament.html">{tournament?.title}</a>*/}
                    </h3>
                    <div className="tournament__tabs">
                        <ul
                            className="nav nav-tabs tabs-nav w-100 gap-2"
                            id="tabs-nav11"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <button type="button"
                                        className={`tabs-nav__btn ${activeTab === 'games' ? 'active' : ''}`}
                                        onClick={e => setActiveTab('games')}
                                >
                                    {t('tournaments.games')}
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button type="button"
                                        onClick={e => setActiveTab('leaderboard')}
                                        className={`tabs-nav__btn ${activeTab === 'leaderboard' ? 'active' : ''}`}>
                                    {t('tournaments.leaderboard')}
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="tournament__wrap">
                        <div className="tab-content">

                            {
                                activeTab === 'games' ?
                                    <TournamentGames
                                        id={tournament.id}
                                        games={tournament?.games || []}/>
                                    :
                                    <TournamentLeaderboard uuid={tournament.uuid}/>
                            }


                        </div>
                    </div>
                    <div className="tournament__cta">

                        <div className="tournament__countdown">
                            {
                                !tournament?.is_completed ?

                                    <Countback
                                        showTitle={false}
                                        showDesc={false} nextDate={tournament.end}/>
                                    : null
                            }
                        </div>

                        <FormButton
                            isSmall={true}
                            label={t('tournaments.learn-more')}
                            loading={false}
                            disabled={false}
                            onClick={handleDetail}
                        />
                    </div>
                </div>
            </div>
        </div>
    )


}

export default TournamentItem
